export function saveDataToLocalStorage(key: string, data: object): void {
  if (data === null || data === undefined) {
    return;
  }
  localStorage.setItem(key, JSON.stringify(data));
}

export function loadDataFromLocalStorage(key: string): object | null {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
}